module.exports = __webpack_public_path__ + "static/media/297354.58f34129.png";